module.exports = __webpack_public_path__ + "img/smithm.ef8ed117.png";